import Dashboard from './pages/DashboardView.vue';
import Templates from './pages/TemplateList.vue';
import TemplatesVersions from './pages/TemplateVersionList.vue';
import TemplateVersionDetail from './pages/TemplateVersionDetailView.vue';
import Placeholders from './pages/PlaceholderList.vue';
import PlaceholderDetail from './pages/PlaceholderDetailView.vue';
import Snippets from './pages/SnippetList.vue';
import SnippetDetail from './pages/SnippetDetailView.vue';
import Directory from './pages/DirectoryView.vue';
import DirectoryFiles from './pages/DirectoryFilesView.vue';
import FileDetail from './pages/FileDetailView.vue';
import Users from './pages/UserList.vue';
import Profile from './pages/ProfileView.vue';
import Settings from './pages/SettingsView.vue';
import Login from './pages/LoginView.vue';
import UITest from './pages/UITestView-origin.vue';
import BatchImportStep1 from './pages/BatchImportStep1.vue';
import BatchImportStep2 from './pages/BatchImportStep2.vue';
import BatchImportStep3 from './pages/BatchImportStep3.vue';
import BatchImportStep4 from './pages/BatchImportStep4.vue';
import Tags from './pages/TagList.vue';
import TagDetail from './pages/TagDetailView.vue';
import Error404NotFound from './pages/Error404NotFound.vue';
import { keeper } from './composables/utils';
import { load } from './composables/useConfig';

export const config = load();

keeper('env', config.env.name);
keeper('apiUrl', config.env.apiUrl);
keeper('fileStorageApiUrl', config.env.fileStorageApiUrl);
keeper('fileStorageBaseUrl', config.env.fileStorageBaseUrl);
keeper('requiredComplexity', config.env.requiredComplexity);
keeper('safe', config.keeper.safe);
keeper('db', config.keeper.safe ? 'sessionStorage' : 'localStorage');
keeper('imageMaxWidth', config.image.maxWidth);
keeper('imageMaxHeight', config.image.maxHeight);
keeper('tz', config.env.tz);
keeper('tzOffset', config.env.tzOffset);
keeper('docker', config.env.docker);
keeper('fileStorageEnabled', config.env.fileStorageEnabled);

export const routes = [
    {
        path: '/',
        component: Dashboard,
        name: 'dashboard',
        meta: { requiredRoles: config.roles.logged, transition: 'slide-left' },
    },
    {
        path: '/templates/:page?',
        component: Templates,
        name: 'templates',
        meta: { requiredRoles: config.roles.readers },
    },
    {
        path: '/template-versions/:templateid/:page?',
        component: TemplatesVersions,
        name: 'template-versions',
        meta: { requiredRoles: config.roles.readers },
    },
    {
        path: '/template-version-edit/:templateid/:templateversionid',
        component: TemplateVersionDetail,
        name: 'template-version-edit',
        meta: { requiredRoles: config.roles.writers },
    },
    {
        path: '/snippets/:page?',
        component: Snippets,
        name: 'snippets',
        meta: { requiredRoles: config.roles.readers },
    },
    {
        path: '/snippet/:snippetid',
        component: SnippetDetail,
        name: 'snippet',
        meta: { requiredRoles: config.roles.writers },
    },
    {
        path: '/tags/:page?',
        component: Tags,
        name: 'tags',
        meta: { requiredRoles: config.roles.readers },
    },
    {
        path: '/tag/:tagid',
        component: TagDetail,
        name: 'tag',
        meta: { requiredRoles: config.roles.writers },
    },
    {
        path: '/directory/:dirname',
        component: DirectoryFiles,
        name: 'directory',
        meta: { requiredRoles: config.roles.readers },
    },
    {
        path: '/files/:page?',
        component: Directory,
        name: 'files',
        meta: { requiredRoles: config.roles.readers },
    },
    {
        path: '/file/:dirname/:filename?',
        component: FileDetail,
        name: 'file',
        meta: { requiredRoles: config.roles.writers },
    },
    {
        path: '/placeholders/:page?',
        component: Placeholders,
        name: 'placeholders',
        meta: { requiredRoles: config.roles.readers },
    },
    {
        path: '/placeholder/:placeholderid',
        component: PlaceholderDetail,
        name: 'placeholder',
        meta: { requiredRoles: config.roles.admins },
    },
    {
        path: '/users/:page?',
        component: Users,
        name: 'users',
        meta: { requiredRoles: config.roles.admins },
    },
    {
        path: '/profile/:userid',
        component: Profile,
        name: 'profile',
        meta: { requiredRoles: config.roles.logged },
    },
    {
        path: '/settings',
        component: Settings,
        name: 'settings',
        meta: { requiredRoles: config.roles.logged },
    },
    {
        path: '/login',
        component: Login,
        name: 'login',
        meta: { requiredRoles: config.roles.all },
    },
    {
        path: '/ui-test',
        component: UITest,
        name: 'ui-test',
        meta: { requiredRoles: config.roles.all },
    },
    {
        path: '/batch-import-1/:page?',
        component: BatchImportStep1,
        name: 'batch-import-1',
        meta: { requiredRoles: config.roles.logged },
    },
    {
        path: '/batch-import-2/:templateid/:page?',
        component: BatchImportStep2,
        name: 'batch-import-2',
        meta: { requiredRoles: config.roles.logged },
    },
    {
        path: '/batch-import-3/:templateid/:templateversionid',
        component: BatchImportStep3,
        name: 'batch-import-3',
        meta: { requiredRoles: config.roles.logged },
    },
    {
        path: '/batch-import-4/:templateid/:templateversionid',
        component: BatchImportStep4,
        name: 'batch-import-4',
        meta: { requiredRoles: config.roles.logged },
    },
    {
        path: '/404',
        component: Error404NotFound,
        name: 'error404',
        meta: { requiredRoles: config.roles.all },
    },
];

export const boot = () => {
    return {
        config: config,
        routes: routes,
    };
};

export default boot;
